export default __webpack_public_path__ + "static/media/scdream8.6d5c3004.woff2";